import IApiResponse from '@customTypes/IApiResponse';
import { useRecaptchaToken } from '@/composables/useRecaptcha';
import axios from 'axios';
import { create } from '@/composables/useNotifications';
import { EDITOR_REQUEST_HEADERS } from '@/composables/useEditorSession';

export default (sendTestEmailUrl: string) => {
    const { getRecaptchaToken } = useRecaptchaToken();

    const sendTestEmail = async (
        emails: string[],
        html: unknown,
        subject?: string
    ) => {
        const token = await getRecaptchaToken('editorSendTestEmail');

        if (!token) {
            create({
                title: 'ReCaptcha verification failed. Please try refreshing the page or using a different browser.',
                type: 'error',
            });
            return;
        }

        return await axios.post<IApiResponse<unknown>>(
            sendTestEmailUrl,
            {
                html: html,
                emails: emails,
                subject: subject,
                recaptcha_token: token,
            },
            { headers: EDITOR_REQUEST_HEADERS }
        );
    };

    return {
        sendTestEmail,
    };
};
